import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { ADMIN_SESSION_EXPIRED_EVENT } from '../../utils/sessionExpiryEvents';

const SessionExpiryDialog = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const onExpired = (event) => {
      setMessage(event.detail?.message || 'Your session has expired.');
      setOpen(true);
    };

    window.addEventListener(ADMIN_SESSION_EXPIRED_EVENT, onExpired);
    return () => window.removeEventListener(ADMIN_SESSION_EXPIRED_EVENT, onExpired);
  }, []);

  const handleClose = () => {
    setOpen(false);
    window.location.href = '/admin/login';
  };

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="session-expired-title">
      <DialogTitle id="session-expired-title">Session expired</DialogTitle>
      <DialogContent>
        <Typography component="div" sx={{ whiteSpace: 'pre-line' }}>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="primary">
          Go to login
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiryDialog;
